import type { ValueFormatterParams } from 'ag-grid-community';
import moment from 'moment';

/**
 * utcをyyyy-MM-dd hh:mm:ssにフォーマット
 * @param ValueFormatterParams
 * @returns YYYY-MM-DD HH:MM:SS
 */
const dateFormatter = (params: ValueFormatterParams) => {
  const value = params.value;
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm:SS');
  } else {
    return null;
  }
};

export default dateFormatter;
